import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
export default {
  methods: {
    changeShapeColor(color) {
      if (this.activeObject != null && (this.activeObject.type === 'shape' || this.activeObject.ImageType === 'SVGImage') && this.activeObject.isGradient) {

        const alpha = parseFloat(color.split(",")[3]);
        let selectedObject = this.contentList.find(element => element.isSelected == true);
        selectedObject.gradient.colors.find((color) => color.isSelected).rgba = alpha > 0 ? color : 'rgba(255, 255, 255, 0)';
        EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);

        if (selectedObject.ImageType === 'SVGImage') {
          EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR);
        }
      }

      if (this.activeObject != null && (this.activeObject.type === 'shape')) {
        this.activeObject.DefaultColor = color;
        EventBus.$emit('updateProductColor');
      }

      if (this.activeObject != null && this.activeObject.type === 'shape' && this.activeObject.shapeType === 'svgShapes') {
        const svgElement = document.getElementById(this.activeObject.Id).firstChild.firstChild;
        svgElement && svgElement.setAttribute('fill', color);
        this.activeObject.svgContent = svgElement.outerHTML;
      }
      this.addIntoPageWiseUndoRedoArray_MixinFun('change shape color');
    },
    changeShapeStroke(color) {
      if (this.activeObject != null && (this.activeObject.type === 'shape')) {
        this.activeObject.StrokeColor = color;
        EventBus.$emit('updateProductColor');
      }

      console.log('Changing stroke');
      if (this.activeObject != null && this.activeObject.type === 'shape' && this.activeObject.shapeType === 'svgShapes') {
        const svgElement = document.getElementById(this.activeObject.Id).firstChild.firstChild;
        const lines      = svgElement.querySelectorAll('line, path, rect, ellipse, polygon');
        if (lines.length) {
          for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
            lines[lineIndex].style.stroke = color;
          }
        }

        this.activeObject.svgContent = svgElement.outerHTML;
      }
      this.addIntoPageWiseUndoRedoArray_MixinFun('change shape color');
    },
  },
};
